//This is based on the standard routerLink directive

import { Attribute, Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { NavigatorService } from '@core/framework/navigator.service';



@Directive({ selector: ':not(a):not(area)[Link]' })
export class M4URouterLinkEx
{

    private commands: any[] = [];
    constructor(
        private Navigator: NavigatorService,
        @Attribute('tabindex') tabIndex: string,
        renderer: Renderer2,
        el: ElementRef)
    {
        if (tabIndex == null) renderer.setAttribute(el.nativeElement, 'tabindex', '0');
    }

    @Input()
    set Link(commands: any[] | string)
    {
        this.commands = Array.isArray(commands) ? commands : [commands];
    }

    @Input()
    public LinkQueryParams: any;


    @HostListener('click')
    onClick(): boolean
    {
        this.Navigator.Navigate(this.commands, this.LinkQueryParams);
        return true;
    }

}


@Directive({ selector: 'a[Link],area[Link]' })
export class M4URouterLinkExWithHref
{

    private commands: any[] = [];
    constructor(private Navigator: NavigatorService)
    {
    }

    @Input()
    set Link(commands: any[] | string)
    {
        this.commands = Array.isArray(commands) ? commands : [commands];
    }


    @Input()
    public LinkQueryParams: any;

    @HostListener('click', ['$event.button', '$event.ctrlKey', '$event.metaKey', '$event.shiftKey'])
    onClick(button: number, ctrlKey: boolean, metaKey: boolean, shiftKey: boolean): boolean
    {
        if (button !== 0 || ctrlKey || metaKey || shiftKey) return true;
        this.Navigator.Navigate(this.commands, this.LinkQueryParams);
        return true;
    }

}
